import { requestServerApi, serverApi } from '../api/api';
import { IS_DEMO } from '../config/env-config';

interface ChatInput {
  companyId: string;
  lessonId: string;
  senderId: string;
  receiverId: string;
  message: string;
}

// FIXME 途中参加でもチャットの内容が見られるように読み込み処理が必要なのでは？（本家Zoomではそうなっている
interface IChatService {
  saveOnServer(input: ChatInput): Promise<void>;
}
class ChatServiceApp implements IChatService {
  async saveOnServer(input: ChatInput): Promise<void> {
    try {
      await requestServerApi(() => {
        const { companyId, lessonId, senderId, receiverId, message } = input;
        return serverApi.organizationsControllerPostZoomChat(companyId, lessonId, senderId, receiverId, message);
      });
    } catch (error) {
      console.error(error);
      // FIXME リトライ処理が必要であれば追加
    }
  }
}

/**
 * Demo用なので何もしない
 * */
class ChatServiceDemo implements IChatService {
  async saveOnServer(input: ChatInput): Promise<void> {
    console.log('Demo mode: saveOnServer called', input);
  }
}
export const ChatService: new () => IChatService = IS_DEMO ? ChatServiceDemo : ChatServiceApp;
